import { useNavigate } from 'react-router-dom';
import { ArrowLeft, BookOpen } from 'lucide-react';

const DIARY_PATH = /^\/(portal\/)?diary(\/|\?|$)/;

/**
 * Shown only when the schedule was opened FROM the Site Diary (`?back=/diary/…`):
 * make the change, then hop straight back to the day you were logging.
 */
export function BackToDiary({ className = '' }) {
  const navigate = useNavigate();
  const back = new URLSearchParams(window.location.search).get('back');
  if (!back || !DIARY_PATH.test(back)) return null;
  return (
    <button
      type="button"
      onClick={() => navigate(back)}
      className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-[#F5A623] text-[#1E2530] text-sm font-semibold hover:bg-[#D98E1D] transition-colors ${className}`}
      data-testid="back-to-diary-btn"
    >
      <ArrowLeft className="w-4 h-4" />
      <BookOpen className="w-4 h-4" />
      Back to Site Diary
    </button>
  );
}

export default BackToDiary;
